import React, { useEffect, useState } from "react";
import { DateBox, LoadPanel, NumberBox, SelectBox } from "devextreme-react";

import { DynamicTabb } from "../../../components/DynamicTab/DynamicTab";
import AdminCrumbs from "../components/AdminCrumbs";

import "./FinancialClosePeriod.css";
import { handleGetLocal } from "../../../services/auth-service";
import axios from "axios";
import { Toster } from "../../../components/Toster/Toster";

const FinancialClosePeriod = () => {
  const today = new Date();
  const currentYear = today.getFullYear();

  const months = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  const years = Array.from({ length: 11 }, (_, index) => currentYear - 5 + index);

  const [loading, setLoading] = useState(false);

  const [closeDay, setCloseDay] = useState(5);

  const [financialMonth, setFinancialMonth] = useState(today.getMonth() + 1);

  const [financialYear, setFinancialYear] = useState(currentYear);

  const [periodStart, setPeriodStart] = useState(null);
  const [periodEnd, setPeriodEnd] = useState(null);
  const [closeDate, setCloseDate] = useState(null);
  const [isClosed, setIsClosed] = useState(false);
  const [isManualCloseDate, setIsManualCloseDate] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  const pathname = handleGetLocal("pathURL");

  const handleCancel = () => {
    getFinancialPeriodStatus();
  };

  const getFinancialPeriodStatus = () => {
    if (!financialMonth || !financialYear) return;

    const financialDate = `${financialYear}-${String(financialMonth).padStart(2, "0")}-01`;

    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/Financial/financial-period-status`, {
        params: {
          financialDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((response) => {
        setLoading(false);

        const result = response?.data;

        if (result?.isSuccess && result?.data) {
          const data = result.data;

          setCloseDay(data.closeDay);
          setPeriodStart(new Date(data.periodStartDate));
          setPeriodEnd(new Date(data.periodEndDate));
          setCloseDate(new Date(data.closeDate));
          setIsClosed(data.isClosed);
          setIsManualCloseDate(response?.data?.data?.isManualCloseDate ?? false);
        } else {
          console.log("Unable to load financial period:", result?.message);
        }
      })
      .catch((error) => {
        setLoading(false);

        console.log("Error loading financial period:", error);
      });
  };

  useEffect(() => {
    getFinancialPeriodStatus();
  }, [financialMonth, financialYear]);

  const handleSave = () => {
    if (!closeDay || closeDay < 1 || closeDay > 15) {
      setToastConfig({
        isVisible: true,
        type: "error",
        message: "Financial Cutoff Period must be between 1 and 15 days.",
      });
      return;
    }

    if (!financialMonth || !financialYear || !closeDate) {
      setToastConfig({
        isVisible: true,
        type: "error",
        message: "Please enter all required fields.",
      });
      return;
    }

    setLoading(true);

    axios
      .put(`${process.env.REACT_APP_API_URL}/api/Financial/financial-close-day`, null, {
        params: {
          closeDay: closeDay,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((response) => {
        const result = response?.data;

        if (!result?.isSuccess) {
          setLoading(false);

          setToastConfig({
            isVisible: true,
            type: "error",
            message: result?.message || "Unable to update Financial Cutoff Period.",
          });

          return;
        }

        const payload = {
          financialYear: financialYear,
          financialMonth: financialMonth,
          closeDate: closeDate,
        };

        axios
          .put(`${process.env.REACT_APP_API_URL}/api/Financial/financial-close-date`, payload, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              Domain: `${pathname}`,
            },
          })
          .then((closeDateResponse) => {
            setLoading(false);

            const closeDateResult = closeDateResponse?.data;

            if (closeDateResult?.isSuccess) {
              setToastConfig({
                isVisible: true,
                type: "success",
                message: "Financial close settings updated successfully.",
              });

              getFinancialPeriodStatus();
            } else {
              setToastConfig({
                isVisible: true,
                type: "error",
                message: closeDateResult?.message || "Unable to update financial close date.",
              });
            }

            setTimeout(() => {
              setToastConfig({
                isVisible: false,
                type: "",
                message: "",
              });
            }, 2000);
          })
          .catch((error) => {
            setLoading(false);

            setToastConfig({
              isVisible: true,
              type: "error",
              message: error?.response?.data?.message || "Unable to update financial close date.",
            });

            setTimeout(() => {
              setToastConfig({
                isVisible: false,
                type: "",
                message: "",
              });
            }, 2000);
          });
      })
      .catch((error) => {
        setLoading(false);

        setToastConfig({
          isVisible: true,
          type: "error",
          message: error?.response?.data?.message || "Unable to update Financial Cutoff Period.",
        });

        setTimeout(() => {
          setToastConfig({
            isVisible: false,
            type: "",
            message: "",
          });
        }, 2000);
      });
  };

  return (
    <>
      <LoadPanel shadingColor="rgba(0,0,0,0.15)" visible={loading} delay={10} message="Processing, please be patient" />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />

      <AdminCrumbs title="Financial Close Period" user="Data" />

      <div className="financial-close-page">
        <DynamicTabb />
        <div className="financial-close-header">
          <div className="financial-close-header-left">
            <div className="financial-close-header-icon">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 2V5M17 2V5M3.5 9H20.5M5 4H19C20.1 4 21 4.9 21 6V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V6C3 4.9 3.9 4 5 4Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 13H10M14 13H16M8 17H10M14 17H16"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            <div>
              <h1>Financial Close Period</h1>
              <p>Manage and configure the financial close period settings for the system.</p>
            </div>
          </div>

          <div className="financial-close-screen-number">FN.17</div>
        </div>
        <div className="financial-close-card">
          <section className="financial-close-section">
            <div className="financial-section-heading">
              <div className="financial-section-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
                  <path
                    d="M12 7V12L15.5 14"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div>
                <h2>Default Financial Cutoff</h2>
                <p>Set the default number of days after the month end for financial cutoff.</p>
              </div>
            </div>

            <div className="financial-cutoff-form">
              <div className="financial-form-field">
                <label>
                  Financial Cutoff Period
                  <span className="required">*</span>
                </label>

                <div className="financial-cutoff-control">
                  <NumberBox
                    value={closeDay}
                    min={1}
                    max={15}
                    showSpinButtons={true}
                    onValueChanged={(e) => {
                      const newCloseDay = e.value;

                      setCloseDay(newCloseDay);

                      if (!isManualCloseDate && periodEnd && newCloseDay >= 1 && newCloseDay <= 15) {
                        const calculatedCloseDate = new Date(periodEnd);

                        calculatedCloseDate.setDate(calculatedCloseDate.getDate() + newCloseDay);

                        setCloseDate(calculatedCloseDate);
                      }
                    }}
                  />

                  <div className="financial-days-badge">
                    Days After
                    <br />
                    Month End
                  </div>
                </div>

                <span className="financial-field-help">Enter a value between 1 and 15 days.</span>
              </div>
            </div>
          </section>

          <div className="financial-section-divider" />
          <section className="financial-close-section monthly-section">
            <div className="financial-section-heading">
              <div className="financial-section-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M7 3V6M17 3V6M4 9H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
                  <path d="M8 13H10M14 13H16M8 17H10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </div>

              <div>
                <h2>Monthly Financial Close</h2>
                <p>Define the monthly financial close details.</p>
              </div>
            </div>

            <div className="financial-close-grid">
              <div className="financial-form-field">
                <label>
                  Financial Month
                  <span className="required">*</span>
                </label>

                <SelectBox
                  dataSource={months}
                  valueExpr="id"
                  displayExpr="name"
                  value={financialMonth}
                  searchEnabled={true}
                  onValueChanged={(e) => {
                    setFinancialMonth(e.value);
                  }}
                />
              </div>
              <div className="financial-form-field">
                <label>
                  Financial Year
                  <span className="required">*</span>
                </label>

                <SelectBox
                  dataSource={years}
                  value={financialYear}
                  onValueChanged={(e) => {
                    setFinancialYear(e.value);
                  }}
                />
              </div>
              <div className="financial-form-field">
                <label>Period Start</label>

                <DateBox
                  value={periodStart}
                  type="date"
                  displayFormat="MM/dd/yyyy"
                  readOnly={true}
                  placeholder="Period start date"
                />
              </div>
              <div className="financial-form-field">
                <label>Period End</label>

                <DateBox
                  value={periodEnd}
                  type="date"
                  displayFormat="MM/dd/yyyy"
                  readOnly={true}
                  placeholder="Period end date"
                />
              </div>
              <div className="financial-form-field">
                <label>
                  Close Date
                  <span className="required">*</span>
                </label>

                <DateBox
                  value={closeDate}
                  type="date"
                  displayFormat="MM/dd/yyyy"
                  useMaskBehavior={true}
                  placeholder="Select close date"
                  onValueChanged={(e) => {
                    const selectedDate = e.value;

                    setCloseDate(selectedDate);

                    if (selectedDate && periodEnd && closeDay) {
                      const defaultCloseDate = new Date(periodEnd);

                      defaultCloseDate.setDate(defaultCloseDate.getDate() + closeDay);

                      const selected = new Date(selectedDate);

                      setIsManualCloseDate(selected.toDateString() !== defaultCloseDate.toDateString());
                    }
                  }}
                />
              </div>
              <div className="financial-form-field">
                <label>Status</label>

                <div className="financial-status-control">
                  <span className={`financial-status-dot ${isClosed ? "closed" : "open"}`} />

                  <span>{isClosed ? "Closed" : "Open"}</span>
                </div>
              </div>
            </div>
          </section>
          <div className="financial-close-footer">
            <button type="button" className="financial-cancel-button" onClick={handleCancel}>
              Cancel
            </button>

            <button type="button" className="financial-save-button" onClick={handleSave}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                <path d="M5 3H17L21 7V21H3V3H5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                <path d="M7 3V9H16V3M8 21V14H16V21" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
              </svg>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinancialClosePeriod;
